<template>
  <router-view v-slot="{ Component }">
    <transition
      @enter="scrollTop"
      :name="transitionName"
      :mode="isDesktop ? undefined : 'out-in'"
    >
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script>
export default {
  computed: {
    transitionName() {
      return `slide${this.$route.meta.scrolling}`;
    }
  }
};
</script>

<route>
{
  "name": "Carte e Servizi",
  "redirect": { "name": "Carte" }
}
</route>
